import { mergeProps, splitProps } from "solid-js";
import classNames from "./classnames";
import { useBootstrapPrefix } from "./ThemeProvider";
import { Dynamic } from "solid-js/web";
const defaultProps = {
    as: "small",
};
const FormText = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), [
        "as",
        "bsPrefix",
        "class",
        "muted",
    ]);
    const bsPrefix = useBootstrapPrefix(local.bsPrefix, "form-text");
    return (<Dynamic component={local.as} {...props} class={classNames(local.class, bsPrefix, local.muted && "text-muted")}/>);
};
export default FormText;
